import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/BgImg05.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>Building Game-Changing Business Applications in Texas</h2>
            </div>
            <p>
              TekRevol offers robust app development services with exceptional
              design capabilities to businesses of all industries. What sets us
              apart is our reliability, and steadiness, surpassing other app
              development companies in Texas. We have committed to impact the
              global business ecosystem and allow businesses to unlock financial
              and operational costs through our innovative mobile app solutions.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
